import { DEFAULT_HEDGE_POSITION_STATUS_TABS } from '../../../Blotters/HedgePositionStatus/defaults';
import type { HedgePositionStatusTabProps } from '../../../Blotters/HedgePositionStatus/types';
import { MobileBlotterPanel, type MobileBlotterPanelProps } from './MobileBlotterPanel';

/** Placeholder-only mobile hedge status content; uses `TradingPlaceholder` via `MobileBlotterPanel`. */
export function MobileHedgePositionStatusBlotter(
  props: Omit<MobileBlotterPanelProps<HedgePositionStatusTabProps>, 'defaultTabs'>
) {
  return (
    <MobileBlotterPanel<HedgePositionStatusTabProps> {...props} defaultTabs={DEFAULT_HEDGE_POSITION_STATUS_TABS} />
  );
}
